import React, { useContext, useEffect, useState } from 'react';
import { useOverlayTriggerState } from '@react-stately/overlays';

import { LoginContext } from 'src/lib/LoginContext';
import { WishlistActionContext } from 'src/lib/WishlistActionContext';

import { IAuctionItem } from 'src/pages/CatalogPage/CatalogPage.i';
import { WishlistModal } from 'src/pages/CatalogPage/components/AuctionItems/AuctionItem/AuctionItemActions/CatalogWishlists/WishlistModal/WishlistModal';
import { Button, cn, NotificationBadge, Typography } from '@riac/design-system';
import { IconList } from '@riac/design-system';


interface ICatalogWishlists {
  item: IAuctionItem;
  title: string;
  inverted?: boolean;
  noOptionsBorder?: boolean;
  className?: string;
}

export const CatalogWishlists = (props: ICatalogWishlists) => {
  const { isLoggedIn } = useContext(LoginContext);
  const { addWishlistItem, matchItem } = useContext(WishlistActionContext);

  const [selectedList, setSelectedList] = useState('0');
  const [addedToList, setAddedToList] = useState(false);
  const [inWishlist, setInWishlist] = useState(false);

  const wishlistModalOverlayState = useOverlayTriggerState({});
  const [wishlistModalType, setWishlistModalType] = useState();

  const matches = matchItem(parseInt(props.item.AuctionItemID));

  if(inWishlist != (matches.length > 0))
  {
    setInWishlist(matches.length > 0);
  }

  useEffect(() => {
    if(inWishlist == false)
    {
      setSelectedList('0');
    }
  }, [inWishlist]);

  function showWishlistModal(type) {
    if(!isLoggedIn) return;
    setWishlistModalType(type);
    wishlistModalOverlayState.open();
  }

  const handleAddToWishlist = (event) => {
    if(!isLoggedIn) return;
    showWishlistModal('add');
  };

  async function wishlistSelect(listID) {
    if(listID === '0') {
      setSelectedList('0');
      return;
    }
    if(listID !== '-1') {
      // add item to existing list
      await addWishlistItem(listID, props.item.AuctionItemID);
      setSelectedList(listID);
      setAddedToList(true);
    } else {
      // create new wishlist and add item to it
      showWishlistModal('add');
    }
  }

  return (
    <div className='flex flex-col gap-1'>
      <Typography color='text-lighter' size='xs'>
        {inWishlist && (
          <>
            Added to {matches.length} wishlist{matches.length > 1 ? 's' : ''}
            {' - '}
            <Button
              variant='text'
              className='p-0'
              onPress={handleAddToWishlist}
            >
              Manage
            </Button>
          </>
        ) || (
          <>
            <Button
              variant='text'
              className='p-0'
              onPress={handleAddToWishlist}
            >
              Add to Wishlist
            </Button>
          </>
        )}
      </Typography>
      {wishlistModalOverlayState.isOpen && (
        <WishlistModal
          showWishlist={wishlistModalType === 'show'}
          item={props.item}
          auctionTitle={props.title}
          closeModal={() => wishlistModalOverlayState.close()}
          currentList={parseInt(selectedList)}
          setAddedToList={() => setAddedToList(true)}
        />
      )}
    </div>
  );
};
